
import {Component, Vue} from "vue-property-decorator";
import {SenkronRaporCevap} from "@/services/senkronPlanService";
import {gunDamgasi, seritOzeti, seritTonu} from "@/components/eicrapro/senkron/senkronRaporOzeti";
import {ProgramPaths} from "@/enum/ProgramPaths";

/**
 * İşlemler sayfasındaki gece senkronu şeridi (Faz 3, DEV-2968 / Ö-P2 kararı).
 *
 * Öneri kutusunun HEMEN ÜSTÜNDE durur: sabah bildirimi kullanıcıyı buraya
 * getiriyor ve gecenin sonucu ile o gecenin ürettiği öneriler yan yana okunuyor.
 * O gün koşan plan yoksa şerit hiç render edilmez — boş bir kutu bilgi taşımaz.
 */
@Component
export default class SenkronRaporSeridi extends Vue {
  gun = gunDamgasi();

  get rapor(): SenkronRaporCevap | null {
    return this.$store.getters["senkronPlan/raporByGun"](this.gun);
  }

  get ozet(): string | null {
    return seritOzeti(this.rapor);
  }

  get ton(): string {
    return seritTonu(this.rapor);
  }

  mounted() {
    // Önbellekte varsa istek atılmaz; plan ekranı da aynı günü çekmiş olabilir.
    this.$store.dispatch("senkronPlan/raporYukle", {gun: this.gun});
  }

  planEkraninaGit() {
    const hedef = ProgramPaths.eicrapro + "/senkron-plani";
    if (this.$route.path !== hedef) this.$router.push(hedef);
  }
}
